import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  constructor() { }
  date_end
  date_start
  Interval = 10000;
  private messageSource = new BehaviorSubject<string>("");
  changeVar = this.messageSource.asObservable();
  
  async getDate(start, end){
    if (start <= end) {
      localStorage.setItem('date_start', ("20"+start));
      localStorage.setItem('date_end', ("20"+end));
      firebase.database().ref('users/'+firebase.auth().currentUser.uid).update({
        date_start : start,
        date_end : end 
      })
    }else{
      alert('date invalide')      
    }
    
    
  }

  changeMyVar (message: string) {
    this.messageSource.next(message)
  }
  
  getInterval(){
    return this.Interval;
  }
}
